window.Page = {

    // Let's launch this thing
    liftoff : () => {
        Page.setStickyHeight()
    },

    // My new function block
    setStickyHeight : () => {
        
        
        
    }

};

Page.liftoff()